import type { Card, CardInput, Grade } from "ts-fsrs" with { "resolution-mode": "import" };
declare const require: (name: "ts-fsrs") => typeof import("ts-fsrs", { with: { "resolution-mode": "import" } });
// ts-fsrs ships a CJS runtime entry but ESM-only declarations.
const { createEmptyCard, fsrs, generatorParameters } = require("ts-fsrs") as typeof import("ts-fsrs", { with: { "resolution-mode": "import" } });

export const FLASHCARD_SCHEDULER_VERSION = "ts-fsrs@5.4.2/calepia-1";
export const FLASHCARD_SCHEDULER_PARAMETERS = generatorParameters({
  request_retention: 0.9, maximum_interval: 36_500, enable_fuzz: false,
  enable_short_term: true, learning_steps: ["1m", "10m"], relearning_steps: ["10m"],
});
const scheduler = fsrs(FLASHCARD_SCHEDULER_PARAMETERS);

export function flashcardInitialState(now: Date) { return createEmptyCard(now); }
export function flashcardNextState(state: CardInput, rating: 1 | 2 | 3 | 4, now: Date): Card {
  return scheduler.next(state, now, rating as Grade).card;
}
export function flashcardPreviews(state: CardInput, now: Date) {
  return ([1, 2, 3, 4] as const).map((rating) => ({ rating, due: flashcardNextState(state, rating, now).due.toISOString() }));
}
export type FlashcardSchedulerState = CardInput;
